import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralHowToReferBrandIA = function BrandReferralHowToReferBrandIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_REFER_A_BRAND_TITLE = function BRAND_REFERRALS_REFER_A_BRAND_TITLE(strictLocalize) {
  return strictLocalize({
    id: "1pX4bk",
    defaultMessage: "How to refer a brand"
  });
};
var BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION = function BRAND_REFERRALS_REFER_A_BRAND_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "i4hHoa",
    defaultMessage: "You can invite a brand to sell on Faire by going to “Refer brands” in “Account”, either by adding their email or website or by sharing your referral link with them directly."
  });
};